import HeaderRouteIndicator from "./../../Molecules/HeaderRouteIndicator/HeaderRouteIndicator";
import "./Soporte.scss";
import Jira_Software_blue from "../../../assets/img/Jira_Software_blue.png";
import FS_CONTACTO_TRES_PERFILES_IMAGEN from "../../../assets/img/FS-CONTACTO-TRES-PERFILES-IMAGEN.png";
import { Button } from "./../../Atoms/Button/Button";
import content from "./content";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import { useScrollCtx } from "../../../store/providers/ScrollContext";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";

const Soporte = () => {
	const {language} = useLanguageCtx();
	const { dropdownHeader } = useScrollCtx();

  return (
		<>
			<ChangeableHeaderV2 basic appearSecondNavbar={dropdownHeader} />
			<HeaderRouteIndicator route={content[language].route} />
			<div
				className="soporte-container flex column center-content-items max-width mt-50"
				style={{ height: "500px" }}
			>
				<h5 className="t5 c-yellow center-text no-space mb-25">
					{content[language].soporte_yellow_title}
				</h5>
				<h2 className="t2 no-space mb-25">
					{content[language].acceso_bold_title}
				</h2>
				<img
					src={Jira_Software_blue}
					alt="Jira Software Logo"
					className="mb-25"
				/>
				<img
					src={FS_CONTACTO_TRES_PERFILES_IMAGEN}
					alt="Grupo de Personas"
					className="mb-25"
				/>
				<h4 className="t4 no-space mb-25 center-text">
					{content[language].acceso_bold_text}
				</h4>
				<p className="body-16 no-space mb-25">
					{content[language].acceso_text}
				</p>
				<div className="mb-50">
					<Button
						content={content[language].button_content}
						type="button light-blue"
					/>
				</div>
			</div>
		</>
	);
};

export default Soporte;
